"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDictionary = exports.resetDictionary = void 0;
var Dictionary_1 = require("./Dictionary");
var DictionaryExpected_1 = require("./DictionaryExpected");
var DictionaryPatterns_1 = require("./DictionaryPatterns");
var DictionarySpecs_1 = require("./DictionarySpecs");
var DictionaryDescription_1 = require("./DictionaryDescription");
var DictionaryTags_1 = require("./DictionaryTags");
var ulid_1 = require("ulid");
var DictionaryAllows_1 = require("./DictionaryAllows");
var createEmptyDictionaryWithId = function (id) {
    return new Dictionary_1.Dictionary({
        id: new Dictionary_1.DictionaryIdentifier(id),
        description: new DictionaryDescription_1.DictionaryDescription(""),
        expected: new DictionaryExpected_1.DictionaryExpected(""),
        patterns: new DictionaryPatterns_1.DictionaryPatterns([]),
        allows: new DictionaryAllows_1.DictionaryAllows([]),
        tags: new DictionaryTags_1.DictionaryTags([]),
        specs: new DictionarySpecs_1.DictionarySpecs({
            specs: []
        })
    });
};
exports.resetDictionary = function (dictionary) {
    return createEmptyDictionaryWithId(dictionary.id.toValue());
};
exports.createDictionary = function () {
    return createEmptyDictionaryWithId(ulid_1.ulid());
};
//# sourceMappingURL=DictionaryFactory.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionaryFactory.js
// module id = 975
// module chunks = 0